module.exports = __webpack_public_path__ + "img/0.e6063116.jpg";